module.exports = __webpack_public_path__ + "assets/img/06a.9414f712.jpg";